<template>
  <div class="planned_content">
    <div class="title flex alignCenter">
      {{PlannedTitle}}
    </div>
    <div class="search-pane">
      <pro-search 
        :fileds.sync="Filed"
        :form="queryForm"
        @search="toSearch"
        @reset="handleReset"
      />
    </div>
    <div class="table_bar">
      <div class="active_bar flex justify-between">
        <div>
          <a-button type="primary" @click="handleSubmit">重新提交排线</a-button>
          <a-button  @click="handleAddLine">新增线路</a-button>
        </div>
        <a-button  @click="handleBatchDelete">批量移除</a-button>
      </div>
      <span v-show="selectedRowKeys.length" class="selectTips">{{`已选择${selectedRowKeys.length}项`}}</span>
      <a-table
      :columns="PlannedColumns"
      :data-source="list"
      bordered
       row-key="jsId"
      :pagination="pagination"
      :loading="loading"
      class="wiring-table table-multip"
      :scroll="{x:true}"
      :row-class-name="rowClass"
      :row-selection="{
          fixed:true,
          onChange,
          selectedRowKeys: selectedRowKeys
      }"
      @change="tableChange"
    >
    <template v-for="item in customr" >
      <span :key="item.customrTitle" :slot="item.customrTitle" class="table_header flex alignCenter" >
        {{item.label}}
        <i v-if="isEdit" class="el-icon-edit-outline" @click="handleEditColumn(item)"></i>
      </span>
    </template>
    <template slot="remarks" slot-scope="text, record">
        <span :class="[resultClass(record.remark)]">{{record.id?record.remark?  '失败' : '成功':''}}</span>
      </template>
     <template slot="action" slot-scope="text, record,index">
        <a-button class="active_btn"  type="link" @click="handleEditLine(record,index)">编辑</a-button>
        <a-button class="active_btn delete_btn" type="link" @click="onDelete(record,index)">删除</a-button>
      </template>
    </a-table>
    </div>
    <batchEditDialog ref="batchEditDialog" @onchange="handleOnChange" />
    <editDialog ref="editDialog" @lineEdit="lineEdit" @lineAdd="lineAdd"/>
    <submitDialog ref="submitDialog" />
  </div>
</template>

<script>
import ProSearch from '@/components/TableSearch/index.vue'
import { clone } from "lodash";
import {SearchFiled,PlannedColumns,customr,STATUS} from './const'
import batchEditDialog from './components/batchEditDialog.vue'
import editDialog from './components/editDialog.vue'
import submitDialog from './components/submitDialog.vue'
import {planOriginalInfoList} from './api'

  export default {
    name:'PlannedOrderManage',
    components:{
      ProSearch,
      batchEditDialog,
      editDialog,
      submitDialog,
    },
    data(){
      return{
        queryForm: {},
        PlannedColumns,
        customr,
        dataList:[],// 原始数据
        list:[], // 克隆数据
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30", "40", "50"],
          onShowSizeChange: (current, pageSize) => {
            this.pagination.pageSize = pageSize;
          },
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 条`,
        },
        selectedRowKeys:[],
        maxIndex:null,
        remarks:[],
        planInfo:{},
        loading:false
      }
    },
    computed:{
      isEdit(){
        return !!this.selectedRowKeys.length
      },
      Filed(){
        return SearchFiled.map(item=>{
          if(item.name==='remark'){
            return {...item,prop:{...item.prop,options:this.remarks}}
          }
          return {...item}
        })
      },
      PlannedTitle(){
       const failed= this.dataList.filter(item=>item.remark)
       const success= this.dataList.filter(item=>item.id&&!item.remark)
       return `管理计划单（共计${this.dataList.length}条，${success.length}条成功+${failed.length}条失败）`
      },
      resultClass(){
        return (result)=>{
          return result?'failed':'success'
        }
      }
    },
    created(){
      this.planInfo=this.$route.query
      this.fetchData()
    },
    methods:{
      rowClass(record,index) {
        return `rowSpan${index}`;
      },
      async fetchData(){
        this.loading=true
        try {
          const res=await planOriginalInfoList({planCode:this.planInfo.planCode})
          this.dataList=res.planMsgInfos.reverse().map((item,index)=>{
            return {...item,...item.ext,jsId:index}
          })
          this.list=clone(this.dataList)
          this.remarks=res.remarks.map(item=>{
            return {label:item,value:item}
          })
          this.maxIndex=this.dataList.length
          this.pagination.total=this.list.length
          this.loading=false
        } catch (error) {
          this.loading=false
        }
      },
      toSearch() {
        const {queryForm}=this
        this.list = this.dataList.filter((item) => {
         // eslint-disable-next-line no-nested-ternary
         return (queryForm.result ? queryForm.result === STATUS.SUCCEED ? !item.remark&&item.id : item.remark : true) && (queryForm.remark ? item.remark === queryForm.remark : true)
        });
        this.pagination.total=this.list.length
        this.pagination.current =1
      },
      handleReset() {
        this.queryForm = {
        }
        this.toSearch()
      },
      handleSubmit(){
        this.$refs.submitDialog.show(this.dataList,this.planInfo)
      },
      handleAddLine(){
        this.$refs.editDialog.show()
      },
      handleEditLine(item,index){
        const {current,pageSize}=this.pagination
        this.$refs.editDialog.show(item,(current-1)*pageSize+index)
      },
      lineEdit(form,index){
        this.$set(this.dataList,index,form)
        this.list=clone(this.dataList)
      },
      lineAdd(form){
        this.dataList.unshift({...form,jsId:this.maxIndex})
        // this.$set(this.dataList,this.dataList.length,{...form,jsId:this.maxIndex})
        this.list=clone(this.dataList)
        this.pagination.total=this.dataList.length
        this.maxIndex+=1
      },
      handleBatchDelete(){
        if(!this.selectedRowKeys.length){
          this.$message.warning('请勾选你要删除的数据')
          return
        }
        const data=JSON.parse(JSON.stringify(this.dataList))
        this.selectedRowKeys.forEach(item=>{
          if(data.map(line=>line.jsId).indexOf(item)!==-1){
            data.splice(data.map(line=>line.jsId).indexOf(item),1)
          }
        })  
        this.dataList=data
        this.list=clone(this.dataList)
        this.selectedRowKeys=[]
        this.pagination.total=this.dataList.length
      },
      // 分页信息改变
      tableChange(pagination) {
        let { current } = pagination
        if (pagination.pageSize !== this.pagination.pageSize) {
          current = 1
        }
        this.pagination = {
          ...pagination,
          current,
        };
      },
      onChange(selectedRowKeys){
        this.selectedRowKeys=selectedRowKeys
      },
      handleEditColumn(item){
        const reson={} 
        const value={}
        this.dataList.forEach(line=>{
          if(this.selectedRowKeys.includes(line.jsId)){
            reson[line.remark||'']=line.remark||false
            value[line[item.prop]||'']=line[item.prop]||false
          }
        })
        const resonText=Object.keys(reson).length===1&&reson[Object.keys(reson)[0]]?reson[Object.keys(reson)[0]]:'';
        const valueText=Object.keys(value).length===1&&value[Object.keys(value)[0]]?value[Object.keys(value)[0]]:'';
        this.$refs.batchEditDialog.show(this.selectedRowKeys.length,item,resonText,valueText)
      },
      handleOnChange(value,prop){
        this.dataList=this.dataList.map(item=>{
          if(this.selectedRowKeys.includes(item.jsId)){
            return {...item,[prop]:value}
          }
          return {...item}
        })
        // this.list=clone(this.dataList)
        this.toSearch()
      },
      onDelete(row,index){
        const data=JSON.parse(JSON.stringify(this.dataList))
        data.splice(index,1)
        this.dataList=data
        this.list=clone(this.dataList)
        if(this.selectedRowKeys.length&&this.selectedRowKeys.indexOf(row.jsId)!==-1){
          this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(row.jsId),1)
        }
        this.pagination.total=this.dataList.length
      }
    }
  }
</script>

<style lang="less" scoped>
.planned_content{
  padding: 24px;
}
.table_header{
  width: 100%;
}
.flex{
  display: flex;
}
.alignCenter{
  align-items: center;
}
.justify-between{
  justify-content: space-between;
}
.title{
  font-weight: 700;
  color: #171717;
  line-height: 22px;
  font-size: 18px;
  margin-bottom: 24px;
  position: relative;
  &::before{
    content:'';
    width: 4px;
    height: 16px;
    background-color: #06B880;
    border-radius: 2px;
    display: inline-block;
    position:absolute;
    left: -24px;
  }
}
.search-pane{
  border-bottom: 1px solid #EBEDF0;
}
.table_bar{
  padding:24px 0;
}
.active_bar{
  margin-bottom: 24px;
  button{
    margin-right: 16px;
  }
}
.el-icon-edit-outline{
  margin-left: 12px;
  font-size: 16px;
  color: #06B880;
  cursor: pointer;
}
.active_btn{
  padding: 0;
  margin: 0;
  &::after{
    content: '';
    width: 1px;
    height: 12px;
    background-color: #DCDEE0;
    display: inline-block;
    margin: 0 8px;
  }
}
.active_btn:last-child::after{
  display: none;
}
.delete_btn{
  color:#969799;
}
.success{
  color: #06B880;
}
.failed{
  color: #ED4934 ;
}
.selectTips{
  font-size: 14px;
  color: #333232;
  margin-bottom: 12px;
  display: inline-block;
}
</style>